import React from 'react';

import * as OrganizationActions from 'actions/OrganizationActions';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {BenchlingApp} from 'constants/UserConstants';
import {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import {EntityWithText} from 'ui-library/entity-input/EntityInputConstants';
import {SingleEntityInput} from 'ui-library/entity-input/SingleEntityInput';
import {TagsInputSize} from 'ui-library/tags-input/TagsInputConstants';
import {isEnterKey} from 'util/Keyboard';

import * as OrganizationConstants from './OrganizationConstants';

interface Props {
  organizationId: string;
  organizationMembers: Array<OrganizationConstants.Member> | null;
}

/**
 * Input to allow searchings for apps to add or invite to the org.
 */
export default function AddBenchlingAppInput(props: Props): JSX.Element {
  function handleSubmit({entity}: {entity: BenchlingApp}): void {
    OrganizationActions.addMember(props.organizationId, entity);
  }

  function filterMembersAndUsers(text: string, options: Array<EntityWithText>): Array<EntityWithText> {
    // If the organization members haven't loaded, don't filter existing members.
    if (!props.organizationMembers) {
      return options;
    }
    // Remove any users
    options = options.filter((o) => o.type === ModelTypeConstants.BENCHLING_APP);
    // Remove any apps already in the organization.
    const existingMemberIds = props.organizationMembers.map((m) => m.id);
    return options.filter((o) => !existingMemberIds.includes(o.id));
  }

  return (
    <SingleEntityInput
      addPredicate={isEnterKey}
      allowEmails={false}
      allowTeams={false}
      allowOrganizations={false}
      allowBenchlingApps={true}
      buttonProps={{
        buttonStyle: ButtonStyle.SECONDARY,
        size: ButtonSize.SMALL,
        text: 'Add App',
      }}
      filterOptions={filterMembersAndUsers}
      onSubmit={handleSubmit}
      size={TagsInputSize.SMALL}
      placeholder="Search for an app"
    />
  );
}
